import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as mainMenuActions from '../../../actions/mainMenuActions';
import * as appHelper from '../../../helpers/appHelper';
import * as actionTypes from '../../../actions/actionTypes';
import {getScreenComponentByType} from '../../../helpers/componentHelper';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as environmentHelper from '../../../helpers/environmentHelper';


class MenuButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            label: appHelper.getLocaleString("menu_label"),
            ariaHasPopup: true,
            env: environmentHelper.getEnvironment(),
        };
        this.setMainMenuStatus = this.setMainMenuStatus.bind(this);
        this.setBtnClass = this.setBtnClass.bind(this);
        this.setIconClass = this.setIconClass.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                label: appHelper.getLocaleString("menu_label"),
            });
        }
    }

    setMainMenuStatus() {
        let disabled = false;
        if(appHelper.isDefined(this.props.disabled)){
            disabled = this.props.disabled;
        }

        if(!disabled) {
            switch (this.props.displayMainMenu) {
                case actionTypes.STATUS_CLOSED:
                    this.props.actions.setMainMenuDisplay(actionTypes.STATUS_OPENING);
                    break;
                case actionTypes.STATUS_OPEN:
                    this.props.actions.setMainMenuDisplay(actionTypes.STATUS_CLOSING);
                    break;
                default:
                    break;
            }
        }
    }

    setKeyboardAccessibility(event){
        if(event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY){
            event.preventDefault();
            this.setMainMenuStatus();
        }
    }

    setBtnClass(){
        let disabled = false;
        if(appHelper.isDefined(this.props.disabled)){
            disabled = this.props.disabled;
        }

       return disabled ? "disabled" : "";
    }

    setIconClass(){
        if(this.props.displayMainMenu === actionTypes.STATUS_OPEN){
            return "icons8-multiply";
        }else{
            return "icons8-menu";
        }
    }

    render() {
        return (

                (appHelper.isDefined(this.props.contentData.experience.show_icons) && this.props.contentData.experience.show_icons) || !appHelper.isDefined(this.props.contentData.experience.show_icons) || this.state.env.isDevice
                    ?
                    <div className={`header-btn ${this.setBtnClass()}`} onClick={this.setMainMenuStatus} onKeyDown={this.setKeyboardAccessibility} id="mainMenuBtn" role="link" tabIndex={!this.props.disabled ? "0" : "-1"} aria-controls="main-menu"  title={this.state.label} aria-haspopup={this.state.ariaHasPopup} aria-disabled={this.props.disabled}>
                        <div className={`icon ${this.setIconClass()} `}/>
                        <div className="btn-label">{this.state.label}</div>
                    </div>
                    :
                    <div className={`header-btn`} onClick={this.setMainMenuStatus} onKeyDown={this.setKeyboardAccessibility} id="mainMenuBtn" role="link" tabIndex={!this.props.disabled ? "0" : "-1"} aria-controls="main-menu"  title={this.state.label} aria-haspopup={this.state.ariaHasPopup} aria-disabled={this.props.disabled}>
                        <div className="nav-label">{this.state.label}</div>
                    </div>



        );
    }
}

MenuButton.propTypes = {
    disabled: PropTypes.bool,
    displayMainMenu: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
    contentData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired

};

MenuButton.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        displayMainMenu: state.displayMainMenu,
        lang:lang,
        contentData: state.contentData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, mainMenuActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MenuButton);



/** WEBPACK FOOTER **
 ** ./src/components/dialogs/mainMenu/MenuButton.js
 **/